export const SpeedometerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M11.4897 8.89895L11.8945 10.1069L12.1617 10.9253C12.8606 13.0958 13.2005 14.4137 13.2005 15C13.2005 16.3807 12.0812 17.5 10.7005 17.5C9.31981 17.5 8.20052 16.3807 8.20052 15C8.20052 14.3434 8.62689 12.769 9.50654 10.1069L9.91136 8.89895C10.1672 8.14479 11.2338 8.14479 11.4897 8.89895ZM10.7005 2.5C15.3029 2.5 19.0339 6.23096 19.0339 10.8333C19.0339 12.5048 18.5399 14.1048 17.6293 15.4647C17.3732 15.8471 16.8556 15.9495 16.4732 15.6934C16.0908 15.4374 15.9884 14.9198 16.2445 14.5373C16.9727 13.4497 17.3672 12.172 17.3672 10.8333C17.3672 7.15143 14.3824 4.16667 10.7005 4.16667C7.01862 4.16667 4.03385 7.15143 4.03385 10.8333C4.03385 12.172 4.42831 13.4497 5.15659 14.5373C5.41266 14.9198 5.31023 15.4374 4.92782 15.6934C4.5454 15.9495 4.02779 15.8471 3.77172 15.4647C2.86112 14.1048 2.36719 12.5048 2.36719 10.8333C2.36719 6.23096 6.09815 2.5 10.7005 2.5ZM10.7005 11.8325L10.4268 12.7164L10.2376 13.3588C9.9921 14.2175 9.86719 14.7736 9.86719 15C9.86719 15.4602 10.2403 15.8333 10.7005 15.8333C11.1608 15.8333 11.5339 15.4602 11.5339 15C11.5339 14.7232 11.3471 13.9534 10.9815 12.7404L10.7005 11.8325Z"
      fill="currentColor"
    />
  </svg>
);
